import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import styles from './quickLaunchDropdownItem.scss'

class QuickLaunchDropdownItem extends PureComponent {
	render() {
		const props = this.props

		return (
			<li styleName='item' onClick={this.props.onClick}>
				<Isvg styleName='item-icon' src={props.icon} cacheGetRequests={true} />
				<span styleName='item-text'>
					{props.text}
					{ props.secondaryIcon &&
						<Isvg
							styleName='item-text-icon'
							src={props.secondaryIcon}
							cacheGetRequests={true}
						/>
					}
				</span>
			</li>
		)
	}
}

QuickLaunchDropdownItem.defaultProps = {
	secondaryIcon: null,
	onClick: () => {},
}

QuickLaunchDropdownItem.propTypes = {
	icon: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	secondaryIcon: PropTypes.string,
	onClick: PropTypes.func,
}

export default CSSModules(QuickLaunchDropdownItem, styles, {allowMultiple: true})
